import { requestAxios } from 'services/api';
import { scoreReportFactory, scoreResumeFactory } from 'factories';
import { ScoreReport, ScoreResume } from 'types';

interface GetParams {
  store: string | null;
  currentPage: number;
  pageSize: number;
  startDate: number;
  endDate: number;
}

async function get(params: GetParams): Promise<ScoreReport> {
  const response = await requestAxios.get('reports/score/days', {
    params,
  });

  const result = response.data;

  return scoreReportFactory(result);
}

interface GetResumeParams {
  store: string | null;
}

async function getResume(params: GetResumeParams): Promise<ScoreResume> {
  const response = await requestAxios.get('reports/score/resume', {
    params,
  });

  const result = response.data;

  return scoreResumeFactory(result);
}

export const scoreReportService = {
  get,
  getResume,
};
